export default __webpack_public_path__ + "static/media/shared_group.b88da484.svg";